const Wording = {
  aboveCanvas: {
    en: 'AI will score your handwriting letter!',
    ja: '字の読みやすさを AI が採点します',
  },
  aboveCanvas2: {
    en: 'Please write on hiragana or kanakata letter !',
    ja: 'ひらがなかカタカナを一文字書いて下さい',
  },
  scoreButton: {
    en: 'Score',
    ja: '採点',
  },
  lineWeightButton: {
    en: 'Line Weight',
    ja: '線の太さ',
  },
  resetButton: {
    en: 'Reset',
    ja: '書き直し',
  },

  predicted: {
    en: 'is ... ',
    ja: 'は …',
  },
};

export default Wording;
